import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource';
import router from './router';
import VueRouter from 'vue-router';
import AuthService from "./shared/auth/auth.service.js";
import ToastService from 'primevue/toastservice';

Vue.use(VueRouter)
Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(ToastService)

new Vue({
    router,
    render: h => h(App, {})
}).$mount('#app')

Vue.http.interceptors.push((request, next) => {
    request.headers.set("Authorization", `Bearer ${AuthService.currentAccessToken}`);
    request.headers.set("Accept", "application/json");
    next();
});